import { IClinicListResponseData } from "@/api_framework/api_modals/Clinics";
import {
  IBOMSetupListResponseData,
  IClinicToClinicToNumberResponse,
  IClinicToClinicTransferBrandResponseData,
  IClinicToClinicTransferStatusResponseData,
  IClinicToClinicWarehouseByCategoryIdResponseData,
  IGRNDetailResponseData,
  IGRNShortReceiveReasonResponseData,
  IGoodInventoryReasonResponseData,
  IInventoryBadStatusListResponseData,
  IInventoryBatchListResponseData,
  IInventoryCountryListResponseData,
  IInventoryManufacturereListResponseData,
  IInventoryProductGeneralDetailsResponseData,
  IInventoryProductListResponseData,
  IInventoryPurchaseOrderDraftPropsBody,
  IInventoryPurchaseOrderListResponseData,
  IInventoryPurchaseOrderListSearchPropsBody,
  IInventoryTaxListResponseData,
  IPODiscountResponseData,
  IPOUnitResponseData,
  IProductParentThemeResponseData,
  IProductParentTitleResponseData,
  IShrinkReasonsResponseData,
  IEMRSectionResponseData,
  ICouponserviceCategoryResponseData,
  ISubCategoryListResponseData,
  ICategorySubCategoryMappingResponseData,
  ITransferOrderDetailsResponseData,
  ToInventoryItems,
  IAddInventoryReasonResponseData,
  IAddInventoryPostBody,
  IMrpUpdateSearchPostBody,
  IMrpUpdatePostBody,
  IAuditTrailActionResponseData,
  IAuditTrailDataSummaryResponsePostBody,
  IAuditTrailExportCSVClinicPostResponseData,
  IGroupItemsListResponseData,
  IProductSubDetailsResponseData,
  IPetBreedResponseData,
  IPackSellEligibilityResponseData,
  IPODeleteAwaitingGRNFilterBody,
  IPOExtractInvoiceDetailsResponseData,
  IFinancePurchaseOrderListResponseData,
  IBOMVialTypeResponseData,
  IBOMVaccineFamilyDoseResponseData,
  IBOMSampleTypeResponseData,
  IBOMLisParameterResponseData,
  IServiceBillableResponseData,
  IProductSetupMedicineConsumptionUnitResponseData,
} from "@/api_framework/api_modals/Inventory";
import { IOrgCityListResponseData, IOrgProviderListResponseData } from "@/api_framework/api_modals/Org";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";
import { IPaymentDetailsResponseData, IPaymentModeChangeFilterData } from "@/api_framework/api_modals/payment";

export interface IInventoryState {
  batchList?: IInventoryBatchListResponseData[] | null;
  manufacturerList: IInventoryManufacturereListResponseData[] | null;
  manufacturerDetails: IInventoryManufacturereListResponseData | null;
  countryList: IInventoryCountryListResponseData[] | null;
  taxList: any | null;
  taxDetails: IInventoryTaxListResponseData | null;
  productList: IInventoryProductListResponseData | null;
  clinics?: IClinicListResponseData[] | null;
  cities?: IOrgCityListResponseData[] | null;
  providers?: IOrgProviderListResponseData[] | null;
  purchaseOrderList: IInventoryPurchaseOrderListResponseData[];
  purchaseOrderDetails: IInventoryPurchaseOrderDraftPropsBody | null;
  purchaseOrderFilter: IInventoryPurchaseOrderListSearchPropsBody | null;
  shortReceiveReasonList: IGRNShortReceiveReasonResponseData[] | null;
  unitList: IPOUnitResponseData[] | null;
  discountList: IPODiscountResponseData[] | null;
  activePOId: string;
  transferOrderGRNId: string;
  activeGRNId: string;
  activePONumber: string;
  GRNDetails: IGRNDetailResponseData | null;
  reasonList: IGoodInventoryReasonResponseData[] | null;
  statusList: IInventoryBadStatusListResponseData[] | null;
  transferStatusList: IClinicToClinicTransferStatusResponseData[] | null;
  transferBrandList: IClinicToClinicTransferBrandResponseData[] | null;
  toNumber: IClinicToClinicToNumberResponse | null;
  transferInventoryItems: ToInventoryItems | null;
  toDetails: ITransferOrderDetailsResponseData | null;
  parentThemeList: IProductParentThemeResponseData[] | null;
  parentTitleList: IProductParentTitleResponseData[] | null;
  productCopyDetails: IInventoryProductGeneralDetailsResponseData | null;
  bomSetupList: IBOMSetupListResponseData[] | null;
  clinicWarehouseDetails: IClinicToClinicWarehouseByCategoryIdResponseData[] | null;
  service_id: string;
  shrinkReasonsList: IShrinkReasonsResponseData[] | null;
  emrSectionList: IEMRSectionResponseData[] | null;
  categoryList: ICouponserviceCategoryResponseData | null;
  subCategoryList: ISubCategoryListResponseData | null;
  categoryMappingList: ICategorySubCategoryMappingResponseData | null;
  addInventoryReasonList: IAddInventoryReasonResponseData[] | null;
  addInventoryOnboard: IAddInventoryPostBody | null;
  mrpUpdateSearch: IMrpUpdateSearchPostBody[] | null;
  mrpUpdate: IMrpUpdatePostBody | null;
  paymentDetails: IPaymentDetailsResponseData | null;
  paymentModeChange: IPaymentModeChangeFilterData | null;
  auditTrailAction: IAuditTrailActionResponseData[] | null;
  auditTrailTableSummaryData: IAuditTrailDataSummaryResponsePostBody | null;
  clinicTamsData: IAuditTrailExportCSVClinicPostResponseData[] | null;
  auditTrailFilterSelection: {
    type: "CLINIC" | "TAMS" | "DOCTOR";
    clinics: string[];
    doctors: string[];
  } | null;
  groupItemsList: IGroupItemsListResponseData | null;
  deletePOAwaitingGRN: IPODeleteAwaitingGRNFilterBody | null;
  extractInvoiceDetails: IPOExtractInvoiceDetailsResponseData | null;
  financePurchaseOrderList?: IFinancePurchaseOrderListResponseData[] | null;
  dayClosureFilter: null;
  productSubDetails: IProductSubDetailsResponseData | null;
  breedSpecificList: IPetBreedResponseData[] | null;
  packEligibility: IPackSellEligibilityResponseData | null;
  bomVialType: IBOMVialTypeResponseData[] | null;
  bomVaccineFamilyDose: IBOMVaccineFamilyDoseResponseData[] | null;
  bomSampleType: IBOMSampleTypeResponseData[] | null;
  bomLisParameters: IBOMLisParameterResponseData[] | null;
  serviceBillable: IServiceBillableResponseData[] | null;
  medicineConsumptionUnit: IProductSetupMedicineConsumptionUnitResponseData[];
}
export interface IInventoryInitialState extends IRouteReducerSliceStateInit {
  state: IInventoryState;
}

const initialState: IInventoryInitialState = {
  state: {
    batchList: [],
    cities: [],
    transferOrderGRNId: null,
    activeGRNId: null,
    activePOId: null,
    activePONumber: null,
    clinics: [],
    providers: [],
    GRNDetails: null,
    manufacturerList: [],
    countryList: [],
    taxList: [],
    purchaseOrderDetails: null,
    productList: { data: [], total_items: 0 },
    manufacturerDetails: null,
    taxDetails: null,
    purchaseOrderList: [],
    productCopyDetails: null,
    purchaseOrderFilter: null,
    shortReceiveReasonList: [],
    unitList: [],
    discountList: [],
    reasonList: [],
    statusList: [],
    transferStatusList: [],
    parentThemeList: [],
    parentTitleList: [],
    transferBrandList: [],
    toNumber: null,
    bomSetupList: [],
    transferInventoryItems: {
      selectedItems: [],
      brands: [],
      subcategories: [],
      senderClinic: { id: "", name: "" },
      searchQuery: "",
      type: "",
      warehouse: "",
      receiverClinic: { id: "", name: "" },
    },
    toDetails: null,
    clinicWarehouseDetails: [],
    service_id: null,
    shrinkReasonsList: [],
    emrSectionList: [],
    categoryList: { data: [], item_count: 0 },
    subCategoryList: { data: [], item_count: 0 },
    categoryMappingList: { data: [], item_count: 0 },
    addInventoryReasonList: [],
    addInventoryOnboard: null,
    mrpUpdateSearch: [],
    mrpUpdate: null,
    paymentDetails: null,
    paymentModeChange: null,
    auditTrailAction: [],
    auditTrailTableSummaryData: null,
    clinicTamsData: [],
    auditTrailFilterSelection: null,
    groupItemsList: null,
    dayClosureFilter: null,
    productSubDetails: null,
    breedSpecificList: [],
    packEligibility: null,
    deletePOAwaitingGRN: null,
    extractInvoiceDetails: null,
    financePurchaseOrderList: [],
    bomVialType: [],
    bomVaccineFamilyDose: [],
    bomSampleType: [],
    bomLisParameters: [],
    serviceBillable: [],
    medicineConsumptionUnit: [],
  },
};

const inventorySlice = createSlice({
  name: "inventory_slice",
  initialState: initialState,
  reducers: {
    RESET_INVENTORY: () => {
      return initialState;
    },
    setInventoryOrgCities: (
      state,
      action: PayloadAction<{
        data: IOrgCityListResponseData[];
      }>,
    ) => {
      state.state.cities = action.payload.data;
    },
    setInventoryOrgProviders: (
      state,
      action: PayloadAction<{
        data: IOrgProviderListResponseData[];
      }>,
    ) => {
      state.state.providers = action.payload.data;
    },
    setInventoryOrgClinics: (
      state,
      action: PayloadAction<{
        data: IClinicListResponseData[];
      }>,
    ) => {
      state.state.clinics = action.payload.data;
    },
    setBatchList: (
      state,
      action: PayloadAction<{
        data: IInventoryBatchListResponseData[];
      }>,
    ) => {
      state.state.batchList = action.payload.data;
    },
    setManufacturerList: (
      state,
      action: PayloadAction<{
        data: IInventoryManufacturereListResponseData[];
      }>,
    ) => {
      state.state.manufacturerList = action.payload.data;
    },
    setManufacturerDetails: (
      state,
      action: PayloadAction<{
        data: IInventoryManufacturereListResponseData | null;
      }>,
    ) => {
      state.state.manufacturerDetails = action.payload.data;
    },
    setCountryList: (
      state,
      action: PayloadAction<{
        data: IInventoryCountryListResponseData[];
      }>,
    ) => {
      state.state.countryList = action.payload.data;
    },
    setTaxList: (
      state,
      action: PayloadAction<{
        data: IInventoryTaxListResponseData[];
      }>,
    ) => {
      state.state.taxList = action.payload.data;
    },
    setTaxDetails: (
      state,
      action: PayloadAction<{
        data: IInventoryTaxListResponseData | null;
      }>,
    ) => {
      state.state.taxDetails = action.payload.data;
    },
    setProductList: (state, action: PayloadAction<IInventoryProductListResponseData>) => {
      state.state.productList = action.payload;
    },
    setPurchaseOrderList: (
      state,
      action: PayloadAction<{
        data: IInventoryPurchaseOrderListResponseData[];
      }>,
    ) => {
      state.state.purchaseOrderList = action.payload.data;
    },
    setPurchaseOrderFilter: (state, action: PayloadAction<{ data: IInventoryPurchaseOrderListSearchPropsBody }>) => {
      state.state.purchaseOrderFilter = action.payload.data;
    },

    setShortReceiveReasonList: (
      state,
      action: PayloadAction<{
        data: IGRNShortReceiveReasonResponseData[];
      }>,
    ) => {
      state.state.shortReceiveReasonList = action.payload.data;
    },
    setUnitList: (
      state,
      action: PayloadAction<{
        data: IPOUnitResponseData[];
      }>,
    ) => {
      state.state.unitList = action.payload.data;
    },
    setDiscountList: (
      state,
      action: PayloadAction<{
        data: IPODiscountResponseData[];
      }>,
    ) => {
      state.state.discountList = action.payload.data;
    },
    setActivePOId: (state, action: PayloadAction<string>) => {
      state.state.activePOId = action.payload;
    },
    setTransferOrderGRNId: (state, action: PayloadAction<string>) => {
      state.state.transferOrderGRNId = action.payload;
    },
    setServiceId: (state, action: PayloadAction<string>) => {
      state.state.service_id = action.payload;
    },
    setActiveGRNId: (state, action: PayloadAction<string>) => {
      state.state.activeGRNId = action.payload;
    },
    setActivePONumber: (state, action: PayloadAction<string>) => {
      state.state.activePONumber = action.payload;
    },
    setPurchaseOrderDetails: (state, action: PayloadAction<IInventoryPurchaseOrderDraftPropsBody>) => {
      state.state.purchaseOrderDetails = action.payload;
    },
    setPOGRNDetails: (state, action: PayloadAction<IGRNDetailResponseData>) => {
      state.state.GRNDetails = action.payload;
    },
    setReasonList: (
      state,
      action: PayloadAction<{
        data: IGoodInventoryReasonResponseData[];
      }>,
    ) => {
      state.state.reasonList = action.payload.data;
    },
    setStatusList: (
      state,
      action: PayloadAction<{
        data: IInventoryBadStatusListResponseData[];
      }>,
    ) => {
      state.state.statusList = action.payload.data;
    },
    setTransferStatusList: (
      state,
      action: PayloadAction<{
        data: IClinicToClinicTransferStatusResponseData[];
      }>,
    ) => {
      state.state.transferStatusList = action.payload.data;
    },
    setParentThemeList: (
      state,
      action: PayloadAction<{
        data: IProductParentThemeResponseData[];
      }>,
    ) => {
      state.state.parentThemeList = action.payload.data;
    },
    setParentTitleList: (
      state,
      action: PayloadAction<{
        data: IProductParentTitleResponseData[];
      }>,
    ) => {
      state.state.parentTitleList = action.payload.data;
    },
    setTransferBrandsList: (
      state,
      action: PayloadAction<{
        data: IClinicToClinicTransferBrandResponseData[];
      }>,
    ) => {
      state.state.transferBrandList = action.payload.data;
    },
    setToNumber: (
      state,
      action: PayloadAction<{
        data: IClinicToClinicToNumberResponse;
      }>,
    ) => {
      state.state.toNumber = action.payload.data;
    },
    setToDetails: (
      state,
      action: PayloadAction<{
        data: ITransferOrderDetailsResponseData;
      }>,
    ) => {
      state.state.toDetails = action.payload.data;
    },
    setTransferInventoryItems: (
      state,
      action: PayloadAction<{
        data: ToInventoryItems;
      }>,
    ) => {
      state.state.transferInventoryItems = action.payload.data;
    },
    setProductCopyDetails: (
      state,
      action: PayloadAction<{
        data: IInventoryProductGeneralDetailsResponseData;
      }>,
    ) => {
      state.state.productCopyDetails = action.payload.data;
    },
    setBOMSetupList: (
      state,
      action: PayloadAction<{
        data: IBOMSetupListResponseData[];
      }>,
    ) => {
      state.state.bomSetupList = action.payload.data;
    },
    setClinicWarehouseDetails: (
      state,
      action: PayloadAction<{
        data: IClinicToClinicWarehouseByCategoryIdResponseData[];
      }>,
    ) => {
      state.state.clinicWarehouseDetails = action.payload.data;
    },
    setShrinkReasonsList: (
      state,
      action: PayloadAction<{
        data: IShrinkReasonsResponseData[];
      }>,
    ) => {
      state.state.shrinkReasonsList = action.payload.data;
    },
    setEmrSectionList: (
      state,
      action: PayloadAction<{
        data: IEMRSectionResponseData[];
      }>,
    ) => {
      state.state.emrSectionList = action.payload.data;
    },
    setCategoryList: (state, action: PayloadAction<ICouponserviceCategoryResponseData>) => {
      state.state.categoryList = action.payload;
    },
    setSubCategoryList: (state, action: PayloadAction<ISubCategoryListResponseData>) => {
      state.state.subCategoryList = action.payload;
    },
    setCategoryMappingList: (state, action: PayloadAction<ICategorySubCategoryMappingResponseData>) => {
      state.state.categoryMappingList = action.payload;
    },
    setAddInventoryReasonList: (
      state,
      action: PayloadAction<{
        data: IAddInventoryReasonResponseData[];
      }>,
    ) => {
      state.state.addInventoryReasonList = action.payload.data;
    },
    setAddInventoryOnboard: (state, action: PayloadAction<{ data: IAddInventoryPostBody }>) => {
      state.state.addInventoryOnboard = action.payload.data;
    },
    setMrpUpdateSearch: (state, action: PayloadAction<{ data: IMrpUpdateSearchPostBody[] }>) => {
      state.state.mrpUpdateSearch = action.payload.data;
    },
    setMRPUpdate: (state, action: PayloadAction<{ data: IMrpUpdatePostBody }>) => {
      state.state.mrpUpdate = action.payload.data;
    },
    setPaymentDetails: (state, action: PayloadAction<{ data: IPaymentDetailsResponseData }>) => {
      state.state.paymentDetails = action.payload.data;
    },
    setPaymentModeChange: (state, action: PayloadAction<{ data: IPaymentModeChangeFilterData }>) => {
      state.state.paymentModeChange = action.payload.data;
    },
    setAuditTrailAction: (
      state,
      action: PayloadAction<{
        data: IAuditTrailActionResponseData[];
      }>,
    ) => {
      state.state.auditTrailAction = action.payload.data;
    },
    setAuditTrailTableSummaryData: (
      state,
      action: PayloadAction<{
        data: IAuditTrailDataSummaryResponsePostBody;
      }>,
    ) => {
      state.state.auditTrailTableSummaryData = action.payload.data;
    },
    setClinicTamsData: (
      state,
      action: PayloadAction<{
        data: IAuditTrailExportCSVClinicPostResponseData[];
      }>,
    ) => {
      state.state.clinicTamsData = action.payload.data;
    },
    setAuditTrailFilterSelection: (
      state,
      action: PayloadAction<{
        data: {
          type: "CLINIC" | "TAMS" | "DOCTOR";
          clinics: string[];
          doctors: string[];
        };
      }>,
    ) => {
      state.state.auditTrailFilterSelection = action.payload.data;
    },
    setGroupItemsList: (state, action: PayloadAction<IGroupItemsListResponseData>) => {
      state.state.groupItemsList = action.payload;
    },
    setDayClosureFilter: (state, action: PayloadAction<any>) => {
      state.state.dayClosureFilter = action.payload;
    },
    setProductSubDetails: (state, action: PayloadAction<IProductSubDetailsResponseData>) => {
      state.state.productSubDetails = action.payload;
    },
    setBreedSpecific: (state, action: PayloadAction<IPetBreedResponseData[]>) => {
      state.state.breedSpecificList = action.payload;
    },
    setPackEligibility: (state, action: PayloadAction<IPackSellEligibilityResponseData>) => {
      state.state.packEligibility = action.payload;
    },
    setPoAwaitingGRNDelete: (state, action: PayloadAction<{ data: IPODeleteAwaitingGRNFilterBody }>) => {
      state.state.deletePOAwaitingGRN = action.payload.data;
    },
    setExtractInvoiceDetails: (state, action: PayloadAction<{ data: IPOExtractInvoiceDetailsResponseData }>) => {
      state.state.extractInvoiceDetails = action.payload.data;
    },
    setFinancePurchaseOrderListAPI: (
      state,
      action: PayloadAction<{
        data: IFinancePurchaseOrderListResponseData[];
      }>,
    ) => {
      state.state.financePurchaseOrderList = action.payload.data;
    },
    setBomVialType: (state, action: PayloadAction<{ data: IBOMVialTypeResponseData[] }>) => {
      state.state.bomVialType = action.payload.data;
    },
    setBomVaccineFamilyDose: (state, action: PayloadAction<{ data: IBOMVaccineFamilyDoseResponseData[] }>) => {
      state.state.bomVaccineFamilyDose = action.payload.data;
    },
    setBomSampleType: (state, action: PayloadAction<{ data: IBOMSampleTypeResponseData[] }>) => {
      state.state.bomSampleType = action.payload.data;
    },
    setBomLisParameters: (state, action: PayloadAction<{ data: IBOMLisParameterResponseData[] }>) => {
      state.state.bomLisParameters = action.payload.data;
    },
    setServiceBillable: (state, action: PayloadAction<{ data: IServiceBillableResponseData[] }>) => {
      state.state.serviceBillable = action.payload.data;
    },
    setMedicineConsumptionUnit: (
      state,
      action: PayloadAction<{ data: IProductSetupMedicineConsumptionUnitResponseData[] }>,
    ) => {
      state.state.medicineConsumptionUnit = action.payload.data;
    },
  },
});

export const {
  setBatchList,
  setManufacturerList,
  setCountryList,
  setManufacturerDetails,
  setTaxList,
  setTaxDetails,
  RESET_INVENTORY,
  setProductList,
  setInventoryOrgCities,
  setInventoryOrgClinics,
  setPOGRNDetails,
  setInventoryOrgProviders,
  setPurchaseOrderList,
  setPurchaseOrderFilter,
  setShortReceiveReasonList,
  setUnitList,
  setReasonList,
  setStatusList,
  setTransferStatusList,
  setParentThemeList,
  setParentTitleList,
  setTransferBrandsList,
  setDiscountList,
  setTransferOrderGRNId,
  setServiceId,
  setActiveGRNId,
  setActivePOId,
  setActivePONumber,
  setPurchaseOrderDetails,
  setToNumber,
  setTransferInventoryItems,
  setToDetails,
  setClinicWarehouseDetails,
  setProductCopyDetails,
  setBOMSetupList,
  setShrinkReasonsList,
  setEmrSectionList,
  setCategoryList,
  setSubCategoryList,
  setCategoryMappingList,
  setAddInventoryReasonList,
  setAddInventoryOnboard,
  setMrpUpdateSearch,
  setMRPUpdate,
  setPaymentDetails,
  setPaymentModeChange,
  setAuditTrailAction,
  setAuditTrailTableSummaryData,
  setClinicTamsData,
  setAuditTrailFilterSelection,
  setGroupItemsList,
  setDayClosureFilter,
  setProductSubDetails,
  setBreedSpecific,
  setPackEligibility,
  setPoAwaitingGRNDelete,
  setExtractInvoiceDetails,
  setFinancePurchaseOrderListAPI,
  setBomVialType,
  setBomVaccineFamilyDose,
  setBomSampleType,
  setBomLisParameters,
  setServiceBillable,
  setMedicineConsumptionUnit,
} = inventorySlice.actions;
export default inventorySlice.reducer;
